var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.194.358L4.418 5.134 2.03 2.746a1.154 1.154 0 00-1.672 0 1.154 1.154 0 000 1.672l3.224 3.224c.239.239.478.358.836.358s.597-.12.836-.358l5.612-5.612a1.154 1.154 0 000-1.672 1.154 1.154 0 00-1.672 0z",
    fill: "#005FF9",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNOS4xOTQuMzU4TDQuNDE4IDUuMTM0IDIuMDMgMi43NDZhMS4xNTQgMS4xNTQgMCAwIDAtMS42NzIgMCAxLjE1NCAxLjE1NCAwIDAgMCAwIDEuNjcybDMuMjI0IDMuMjI0Yy4yMzkuMjM5LjQ3OC4zNTguODM2LjM1OHMuNTk3LS4xMi44MzYtLjM1OGw1LjYxMi01LjYxMmExLjE1NCAxLjE1NCAwIDAgMCAwLTEuNjcyIDEuMTU0IDEuMTU0IDAgMCAwLTEuNjcyIDB6IiBmaWxsPSIjMDA1RkY5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";
export { SvgMark as ReactComponent };